import lazyLoad from '@loadable/component'

import createPlugin from './createPlugin'

import YouTubeRenderer from '@peracto/peracto-blocks-tailwind/dist/content/YouTube/Renderer/YouTubeRenderer'

const YouTubeForm = lazyLoad(() => import('./Form/YouTubeForm'))

const youtubePlugin = settings =>
    createPlugin({
        Renderer: YouTubeRenderer,

        Controls: YouTubeForm,
        ...settings,
    })

const youtube = youtubePlugin()
export default youtube

export { youtubePlugin, YouTubeRenderer }
